import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Col } from "reactstrap";
import { ErrorMessage } from "../../../../../utils/ErrorMessage";
import { selectInputStyle } from "../../../../../utils/SelectInputStyles";
import { customerTypes } from "../../../../radioTypes/radioTypes";
import InputField from "../../../inputs/InputField";
import MobileNoInputField from "../../../inputs/MobileNoInputField";
import RadioButtonsGroup from "../../../RadioButtonsGroup/RadioButtonsGroup";
import MandatoryField from "../../../../../utils/MandatoryField";
import { toastMessage } from "../../../../commonFunctions";
import { CustomerDetailsFormSchema } from "../FormComponentSchema";
import { CountryListAaray, CountryLists } from "../../../../../pages/Contact/EditContact/EditContactSchema";
import useLocationApi from "../../../../../hooks/useLocationApi";

const CustomerDetailsForm: React.FC<CustomerDetailsFormSchema> = ({
  customerCatArr,
  paymentTermArr,
  membershipArr,
  accountGroupArr,
  customerTaxType,
  register,
  errors,
  control,
  setValue,
  newContactCreatedDetail,
  handleBlurFirstName,
  handleBlurLastName,
  handleBlurCompanyName,
  handleBlurContactNo,
  handleBlurCreditAmount,
  handleBlurDebitAmount,
}) => {
  const { getCountryList } = useLocationApi();
     const taxtype =  
   customerTaxType === "gst" ? "gst" : "vat"
  // :  (sessionList?.governmentTaxType || "gst") ;
  // const taxtype = !newContactCreatedDetail?.ContactDetails?.vatNo?.trim() ? "gst" : "vat";
  const [countryCodeImg, setCountryCodeImg] = useState<CountryLists[]>([]); 
  const accountGroupArrs = accountGroupArr.map(({ label, value }) => ({
    label,
    value: value.toString(),  
  }));

  useEffect(() => {
    const fetchCountryList = async () => {
      try {
        const countryList = await getCountryList();
  
        if (countryList) {
          const parsedResult = CountryListAaray.safeParse(countryList?.response);
            if (parsedResult.success) {
     
            setCountryCodeImg(parsedResult.data)
        
          } else {
            console.error("Parsing error:", parsedResult.error.format());
          }
        } else {
          console.error("Response data is null or undefined.");
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
      }
    };
  
    fetchCountryList();
  }, [newContactCreatedDetail]);

 
  return (
    <>
      <div className="form-container">
      <Col md={"auto"}>
        <InputField
          labelName="First Name"
          placeholder="First Name"
          name="firstName"
          id="firstName"
          register={register}
          onChange={handleBlurFirstName}
          errorMessage={ErrorMessage(errors?.firstName?.message)}
          required
        />
      </Col>
        <Col>
          <InputField
            labelName="Last Name"
            placeholder="Last Name"
            name="lastName"
            id="lastName"
            onChange={handleBlurLastName}
            register={register}
            errorMessage={ErrorMessage(errors?.lastName?.message)}
          />
        </Col>
        <Col md={"auto"}>
          <InputField
            labelName="Company Name"
            placeholder="Company Name"
            name="companyName"
            id="companyName"
            // onChange={handleBlurCompanyName}
            onChange={handleBlurCompanyName}
            register={register}
            errorMessage={ErrorMessage(errors?.companyName?.message)}
          />
        </Col>

        <Col>
          <InputField
            labelName="Code"
            placeholder="Code"
            name="code"
            id="code"
            register={register}
            errorMessage={ErrorMessage(errors?.code?.message)}
          />
        </Col>

        <Col>
          <InputField
            labelName="PAN No."
            placeholder="PAN No."
            name="panNo"
            id="panNo"
            register={register}
            errorMessage={ErrorMessage(errors?.panNo?.message)}
          />
        </Col>
      
      </div>

      <div className="form-container ">
        <Col className="responsive-MobileInput" md={"auto"}>
          <MobileNoInputField
          
            countryCodeImg={countryCodeImg}
            newContactCreatedDetail={newContactCreatedDetail}
            inputName="mobNo"
            name="mobNo"
            id="mobNo"
            labelName="Mobile No."
            control={control}
            errors={errors}
            handleBlur={handleBlurContactNo}
            placeHolder={"Mobile No."}
            setValue={setValue}
            index={0}
          />
          {ErrorMessage(errors?.mobNo?.message)}
        </Col>

        <Col>
          <InputField
            labelName="Telephone No."
            placeholder="Telephone No."
            name="telephone"
            id="telephone"
            register={register}
            onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
              ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault();
            }}
            
            inputType="number"
            errorMessage={ErrorMessage(errors?.telephone?.message)}
          />
        </Col>

        <Col className="responsive-MobileInput" md={"auto"}>
          <MobileNoInputField
          countryCodeImg={countryCodeImg}
            newContactCreatedDetail={newContactCreatedDetail}
            labelName="WhatsApp No."
            inputName="whatsappNo"
            name="whatsappNo"
            id="whatsappNo"
            control={control}
            placeHolder={"WhatsApp No."}
            setValue={setValue}
            index={0}
          />
          {ErrorMessage(errors?.whatsappNo?.message)}
        </Col>

        <Col>
          <InputField
            labelName="Email"
            placeholder="Email"
            name="email"
            id="email"
            register={register}
            errorMessage={ErrorMessage(errors?.email?.message)}
          />
        </Col>

        <Col>
          <InputField
            labelName="Date Of Birth"
            placeholder="Date Of Birth"
            name="dateOfBirth1"
            id="dateOfBirth1"
            inputType="date"
            onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
              const selectedDate = new Date(e.target.value);
              const today = new Date();

              today.setHours(0, 0, 0, 0);

              // Reset the time component of the selected date to midnight
              selectedDate.setHours(0, 0, 0, 0);

              if (selectedDate > today) {
                // Reset the input field or show an error message
                e.target.value = ""; // Optional: Clear the input if the date is invalid
                toastMessage(
                  "The selected date cannot be in the future. Please choose a valid date"
                );
              }
            }}
            register={register}
          />
        </Col>
      </div>

      <div className="form-container">
        <Col className="responsive-input" md={5}>
          <div>
            <RadioButtonsGroup
              formLabel={"Type"}
              name="customerType"
              radioButtonArr={customerTypes}
              control={control}
              defaultValue={"wholesaler"}
            />
          </div>
        </Col>
        <Col className="responsive-input Taxk" style={{maxWidth : '233px' , paddingLeft : '17px'}} >
          <div>
            <RadioButtonsGroup
              formLabel="Tax Type"
              name="customerTaxType"
              radioButtonArr={[
                { label: "GST", value: "gst", default: true },
                { label: "VAT", value: "vat", default: false },
              ]}
              control={control}
              defaultValue={"gst"}
            />
          </div>
        </Col>
        {taxtype === "vat" && (
          <Col>
            <InputField
              labelName="VAT No."
              placeholder="VAT No"
              name="vatNo"
              id="vatNo"
              register={register}
              errorMessage={ErrorMessage(errors?.vatNo?.message)}
            />
          </Col>
        )}

        <Col  className=" mb-lg-0 mb-2">
          <label style={{ fontWeight: 600 }}>
            Account Group
            <MandatoryField />
          </label>
          <Controller
  name={"accountGroupId"}
  control={control}
  render={({ field }) => (
    <Select
      styles={{
        ...selectInputStyle,
        control: (baseStyles) => ({
          ...baseStyles,
          width: "99%",
          paddingRight: "15px",
          minHeight: "30px",
          height: "30px", 
          fontSize: "12px",
          paddingTop: "0px",
          paddingBottom: "0px",
          borderColor: "#ebedf2",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "30px",
          padding: "0 8px",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "30px",
        }),
      }}
      options={accountGroupArrs}
      menuPortalTarget={document.body}
      {...field}
      onChange={(selectedOption) => {
        field.onChange(selectedOption);
      }}
    />
  )}
/>

        </Col>
      </div>

      <div className="form-container mt-2">
        <Col md={"auto"}>
          <InputField
            labelName="Anniversary Date"
            placeholder="Anniversary Date"
            name="anniversaryDate1"
            id="anniversaryDate1"
            register={register}
            onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
              const selectedDate = new Date(e.target.value);
              const today = new Date();

              // Reset the time component of today
              today.setHours(0, 0, 0, 0);
              // Reset the time component of the selected date to midnight
              selectedDate.setHours(0, 0, 0, 0);

              if (selectedDate > today) {
                e.target.value = "";
                toastMessage(
                  "The selected date cannot be in the future. Please choose a valid date"
                );
              }
            }}
            inputType="date"
          />
        </Col>
        {window.location.href.includes("/new") && (
          <>
            <Col>
              <InputField
                labelName="Opening Balance"
                placeholder="Debit Amount"
                name="debitAmount"
                id="debitAmount"
                // className="small-input"
                register={register}
                onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault();
                }}
                errorMessage={ErrorMessage(errors?.debitAmount?.message)}
                inputType="number"
                onBlur={handleBlurDebitAmount}
              />
            </Col>

            <Col md={"auto"}>
              <InputField
                labelName="Credit Amount"
                placeholder="Credit Amount"
                name="creditAmount"
                id="creditAmount"
                hiddenLabel={true}
                register={register}
                onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault();
                }}
                errorMessage={ErrorMessage(errors?.creditAmount?.message)}
                inputType="number"
                onBlur={handleBlurCreditAmount}
              />
            </Col>
          </>
        )}
        <Col>
          <label style={{ fontWeight: 600 }}>Payment Terms</label>
          <Controller
            name={"paymentTermId"}
            control={control}
            render={({ field }) => (
              <Select
                placeholder={"Select Payment Terms"}
                styles={selectInputStyle}
                className="customSelect"
                options={paymentTermArr}
                menuPortalTarget={document.body}
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
            )}
          />
        </Col>
        <Col>
          <InputField
            labelName="Remarks"
            placeholder="Remarks"
            name="remark"
            id="remark"
            register={register}
            errorMessage={ErrorMessage(errors?.remark?.message)}
          />
        </Col>
      </div>

      <div className="form-container mt-2">
        {newContactCreatedDetail?.allowb2b === 1 && (
          <Col md={"auto"}>
            <label style={{ fontWeight: 600 }}>Customer Category</label>
            <Controller
              name={"customerCategoryId"}
              control={control}
              render={({ field }) => (
                <Select
                placeholder={"Customer Category"}
                className="custo_cat"
                styles={{
                  ...selectInputStyle,
                  control: (base, state) => {
                    const originalControl = selectInputStyle.control?.(base, state) || base;
                    return {
                      ...originalControl,
                      width: '210px', // override just this
                    };
                  },
                }}
                // options={customerCatArr}
                options={customerCatArr.map(({ customerCategoryId, customerCategoryName }) => ({
                  value: customerCategoryId?.toString() || "",
                  label: customerCategoryName || "",
                }))}
                menuPortalTarget={document.body}
                isClearable 
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
              
              )}
            />
          </Col>
        )}
        {newContactCreatedDetail?.membership === 1 && (
          <Col md={"auto"}>
            <label style={{ fontWeight: 600 }}>Membership</label>
            <Controller
              name={"membershipId"}
              control={control}
              render={({ field }) => (
                <Select
                  className="customer_details-select"
                  placeholder={"Select Membership"}
                  styles={{
                    ...selectInputStyle,
                    control: (base, state) => {
                      const originalControl = selectInputStyle.control?.(base, state) || base;
                      return {
                        ...originalControl,
                        width: '220px', 
                        maxWidth: '230px', 
                      };
                    },
                  }}
                  // options={membershipArr}
                  options={membershipArr.map(({ membershipId, membershipName }) => ({
                    value: membershipId.toString(),
                    label: membershipName,
                  }))}
                  menuPortalTarget={document.body}
                  {...field}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption);
                  }}
                />
              )}
            />
          </Col>
        )}

        <Col></Col>
        <Col></Col>
        <Col></Col>
      </div>
    </>
  );
};

export default CustomerDetailsForm;
